import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';

// project import
import DefaultTableActions from 'pages/basic/actions/DefaultTableActions';
import DataGrid from './DataGrid';
import { useWindowHeight } from 'hooks/useWindowHeight';
import CustomTableColumnConfigBuilder from 'components/shared/table/column-config-builder/CustomTableColumnConfigBuilder';
import Toolbar from 'components/shared/Toolbar';
import AddDataStandardModalForm from 'pages/basic/crud/AddDataStandardModalForm';
import { plainToInstance } from 'class-transformer';
import { useDispatch } from 'react-redux';
import mt from 'date-fns/esm/locale/mt/index';

const StyledBox = styled('div')(({ theme }) => ({
    '& .MuiDataGrid-cell--editable': {
        '& .MuiInputBase-root': {
            height: '100%',
        },
        ...theme.applyStyles('dark', {
            backgroundColor: alpha(theme.palette.success.main, 0.35),
        }),
    },
    '& .Mui-error': {
        backgroundColor: alpha(theme.palette.error.dark, 0.1),
        color: theme.palette.error.dark,
        ...theme.applyStyles('dark', {
            backgroundColor: 'transparent',
            color: theme.palette.error.light,
        }),
    },
}));

const CommandDataGrid = ({
    service,
    columnsStorageName,
    config,
    tableActionConfig,
    onCommandUpdate,
    onAddCommand,
    data,
}) => {
    const heightWindow = useWindowHeight();

    const entity = service.getModel();

    const availableListActionsConfig = useMemo(() => {
        if (tableActionConfig?.length === 0) return [];
        return DefaultTableActions.createConfig(
            service,
            tableActionConfig?.length > 0 ? tableActionConfig : undefined,
        ).build('entries');
    }, [service, tableActionConfig]);

    const handleOnClickPostAction = action => {
        // if (action === 'delete' || action === 'deactivate') execute();
    };

    const configColumns = new CustomTableColumnConfigBuilder(
        config,
        availableListActionsConfig,
        handleOnClickPostAction,
        entity,
    );

    const handleRowsUpdate = rows => {
        onCommandUpdate(rows);
    };
    const handleOnClose = () => {
        // No action needed on close for now
    };

    const handleOnSubmit = (data, successCallback, errorCallback) => {
        onAddCommand(data, successCallback, errorCallback);
    };

    return (
        <StyledBox
            sx={{
                maxHeight: `${heightWindow * 0.3}px`,
                padding: '0px 24px 24px 24px',
                bgcolor: 'background.paper',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
            }}
            mt={2}
        >
            <Toolbar>
                <AddDataStandardModalForm
                    onClose={handleOnClose}
                    config={config}
                    service={service}
                    entity={entity}
                    onSubmit={handleOnSubmit}
                    style={{
                        position: 'absolute',
                        top: 46,
                        zIndex: 1200,
                    }}
                />
            </Toolbar>
            <div style={{ flexGrow: 1, marginTop: '16px' }}>
                <DataGrid
                    data={data || []}
                    columnsStorageName={columnsStorageName}
                    columns={configColumns}
                    onRowsUpdate={handleRowsUpdate}
                />
            </div>
        </StyledBox>
    );
};

CommandDataGrid.propTypes = {
    title: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.object),
    basePath: PropTypes.string.isRequired,
    service: PropTypes.object.isRequired,
    columnsStorageName: PropTypes.string,
    toolbarActionConfig: PropTypes.array,
    addToolbarActionConfig: PropTypes.array,
    tableActionConfig: PropTypes.array,
    config: PropTypes.arrayOf(PropTypes.object),
    toolbar: PropTypes.element,
};

export default CommandDataGrid;
